import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue"
import { TextInputSize } from "./types"

export interface TextInputProps {
  value: string
  label?: string
  placeholder?: string
  size?: TextInputSize
  className?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextInput',
  props: {
    value: null,
    label: null,
    placeholder: null,
    size: null,
    className: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: string
  label?: string
  placeholder?: string
  size?: TextInputSize
  className?: string
}

const BASE_CLASSES = "ui-text-input"
const BASE_SMALL_CLASSES = "text-input-small"
const BASE_MEDIUM_CLASSES = "text-input-medium"
const BASE_LARGE_CLASSES = "text-input-large"





const inputValue = ref(props.value)

const updateValue = (event: Event) => {
  const target = event.target as HTMLInputElement
  inputValue.value = target.value
  emit("input", target.value)
}

const isSmall = computed(() => props.size === "small")
const isMedium = computed(() => props.size === "medium")
const isLarge = computed(() => props.size === "large")

return { __sfc: true,BASE_CLASSES, BASE_SMALL_CLASSES, BASE_MEDIUM_CLASSES, BASE_LARGE_CLASSES, props, emit, inputValue, updateValue, isSmall, isMedium, isLarge }
}

})